import React, { HTMLAttributes, MouseEventHandler } from 'react';
import { baseBox, centeredBox, disabled } from './box.css';
import { clsx } from 'clsx';

export type BoxProps<T extends HTMLElement = HTMLDivElement> = {
  as?: React.ElementType;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  css?: React.CSSProperties;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  isDisabled?: boolean;
  ref?: React.Ref<T>;
} & React.HTMLAttributes<T>;

export const CenteredBox = (props: HTMLAttributes<HTMLDivElement>) => {
  const { className, ...rest } = props;
  return <div className={clsx(centeredBox, className)} {...rest} />;
};

export const Box = <T extends HTMLElement = HTMLDivElement>({
  as: Comp = 'div',
  children,
  style,
  className,
  css,
  onClick,
  isDisabled,
  ref,
  ...props
}: BoxProps<T>) => {
  return (
    <Comp
      {...props}
      ref={ref}
      style={style || css}
      onClick={onClick}
      className={clsx(baseBox, isDisabled && disabled, className)}
    >
      {children}
    </Comp>
  );
};

// Typescript Tests:
// let a;
// const b1 = <Box href="1" />; // ERROR
// const b2 = <Box direction="1" />; // ERROR
// const b3 = <Box direction="vertical" />; // ERROR
// const b4 = <Box href="1" />; // ERROR
// const b5 = <Box as="a" href="1" />; // ok
// const b6 = <Box onClick={() => 0} />; // ok
// const s1 = <Stack href="1" />; // ERROR
// const s2 = <Stack direction="1" />; // ERROR
// const s3 = <Stack direction="vertical" />; // ok
// const s4 = <Stack href="1" ref={a} as="a" />; // ERROR
// const s5 = <Stack as="section" ref={a} />; // ok
// const s6 = <Stack as="section" href="a" />; // ERROR
